const STORAGE_KEY = "neo_document_jobs_v1";
const MAX_JOBS = 8;

export function readTrackedDocumentJobs() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeTrackedDocumentJobs(jobs) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(jobs.slice(0, MAX_JOBS)));
}

export function trackDocumentJob({ jobId, title, kind = "pdf_generation" }) {
  if (!jobId) return;
  const now = Date.now();
  const jobs = readTrackedDocumentJobs().filter((j) => j.jobId !== jobId);
  jobs.unshift({
    jobId: String(jobId),
    title: title || "Documento",
    kind,
    startedAt: now,
    updatedAt: now,
    status: "pending",
  });
  writeTrackedDocumentJobs(jobs);
}

export function updateTrackedDocumentJob(jobId, patch) {
  if (!jobId) return;
  const jobs = readTrackedDocumentJobs();
  const idx = jobs.findIndex((j) => j.jobId === String(jobId));
  if (idx < 0) return;
  jobs[idx] = {
    ...jobs[idx],
    ...patch,
    updatedAt: Date.now(),
  };
  writeTrackedDocumentJobs(jobs);
}

export function removeTrackedDocumentJob(jobId) {
  if (!jobId) return;
  writeTrackedDocumentJobs(
    readTrackedDocumentJobs().filter((j) => j.jobId !== String(jobId))
  );
}

export const TERMINAL_DOCUMENT_STATUSES = new Set([
  "PDF_GENERATED",
  "SIGNED",
  "ERROR",
  "DELETED",
]);

export function isTerminalDocumentStatus(status) {
  if (!status) return false;
  return TERMINAL_DOCUMENT_STATUSES.has(String(status).toUpperCase());
}
